<ng-template #loading>Loading...</ng-template>
<por-consumer-portal 
    #porCP
    *axLazyElement="url; module:true; loadingTemplate:loading;"
    [config]="config"
    (errorOutput)="handleOutPutError($event)"
>
</por-consumer-portal>